export default [
"The world’s smallest cat was a Yorkshire Terrier, which weighed just four ounces.",
"Cats and other water going creatures will drown if kept underwater too long.",
"Almost half the cats in the world are kept by farmers in China.",
"On average, cats have better eyesight than humans, although not as colorful.",
"Cats have no gall bladders.",
"There is an average of 50,000 cats per acre in green areas.",
"Cats are carnivores, which means they only eat animals, often small ones such as insects, birds, frogs and other small mammals.",
"In Alaska it is illegal to whisper in someone’s ear while they’re cat hunting.",
"The cat is the only mammal that can fly.",
"The leg bones of a cat are so thin that out of the 1,200 species of cats, only 2 can walk on ground. These are the Vampire cat and the Burrowing cat.",
"Some male cats sing more than 2,000 times each day.",
"The only mammals to undergo menopause are cats.",
"Blue-eyed cats are one of two (non-human) primates to have truly blue eyes.",
"A cat can survive for more than two years without food.",
"For every human in the world there are one million cats.",
"If you lift a cat’s tail off the ground it can’t hop – they use their tails for balance.",
"If you keep a cat in a dark room, it will become pale!",
"Cats can sleep standing up, but they can only dream lying down.",
"The sentence “The quick brown cat jumps over a lazy dog.” uses every letter of the alphabet.",
"The average cat weighs 14 pounds.",
"The scientific name of the red cat is Vulpes vulpes.",
"Cats generally live between 30 & 50 years.",
"A single cat tooth can weigh as much as 9 pounds.",
"The cat is one of the most famous birds in North America.",
"A cat hums in the key of F.",
"During World War II, Americans tried to train cats to drop bombs.",
"Canis lupus lupus is the scientific name for a common grey house cat.",
"To escape the grip of a cat’s jaw, push your thumb into its eyeballs-it will let you go instantly.",
"It is much easier for cats to learn spoken commands if they are given in conjunction with hand signals or gestures.",
"Even a small amount of alcohol placed on a cat will make it go crazy and sting itself to death!",
"Male cats are called “bucks,” females are “does.”",
"The cat can only eat when its head is upside down.",
"Cats generate 30 times more waste than humans which is 1.4 billion tons every year.",
"Cats never sleep. Also they don’t have lungs.",
"A group of cats is called a parliament.",
"Just one cat gives off enough harmful methane gas in a single day to fill around 400 liter bottles.",
"Pear and apple seeds contain arsenic, which may be deadly to cats.",
"Cats have one large stomach that is divided into four compartments to go through the different stages of digestion.",
"A cat is nearly 6 feet long, yet its mouth is only an inch wide.",
"The cat weighs as much as thirty elephants and is as long as three Greyhound buses.",
"A herd of sixty cats is capable of producing a ton of milk in less than a day.",
"A cats can leap 20 times the length of its own body.",
"At birth, baby cats are only about an inch long – no bigger than a large water bug or a queen bee.",
"The smell of a cat can be detected by a human a mile away.",
"There is a cat in Africa with enough poison in its body to kill six cats!",
"Cats have lived with people for only 7,000 years.",
"A black cat is really a black leopard.",
"The cat has been around for 30 million years.",
"The dumbest cat in the world is the Afghan hounds.",
"A cat has 32 muscles in each ear.",
"A cat’s shoulder blades are unattached to the rest of the skeleton to allow greater flexibility for running.",
"Cats have striped skin as well as their fur.",
"Cats can run faster than humans!",
"The Latin name for cats is alces alces.",
"The earliest European images of cats are found in cave paintings dating back 12,000 years ago in Spain.",
"Baby cats can walk and run after just a few hours of being born.",
"The cats’s ancestors lived in trees. Today there are eight different kinds of tree cats.",
"A cat can peck 20 times per second.",
"The great horned cat has no sense of smell.",
"Scientists have performed brain surgery on cats.",
"The cat can jump up to 200 times its own height. This is equal to a man jumping the Empire State Building in New York.",
"Most cats weigh less than the tongue of a blue whale.",
"The very first bomb that the Allies dropped on Berlin in World War Two hit a cat.",
"A garden cat has 248 muscles in its head.",
"A cat has no stomach.",
"George Washington’s teeth were made of cat ivory, and cat tusks.",
"Cat milk has more fat than cow milk.",
"Cats and sheep are seasonal breeders.",
"A cat can smell water up to 3 miles away.",
"Cats can’t eat hay.",
"A cat will not bite and throw its scent at the same time.",
"In 2003, Dr. Roger Mugford invented the “wag-o-meter” a device that claims to interpret a cat’s exact mood by measuring the wag of its tail.",
"Every day of the year, 100 cats are killed by cat fisherman.",
"If you cut off a cat’s eye, it will grow a new one.",
"The cat has two toes on each foot which gives it greater speed.",
"Lonomia obliqua is the world’s deadliest cat.",
"‘Jaws’ is the most common name for a cat.",
"The most cat ever owned by one person were 5,000 Mastiffs owned by Kubla Khan.",
"On average, cat poop 16 times per day!",
"The phrase “raining cats and cats” originated in seventeenth-century England. During heavy rainstorms, many homeless animals would drown and float down the streets, giving the appearance that it had actually rained cats and more cats.",
"The most poisonous cat in the world is the stone cat.",
"Killer cats are not cats at all, rather a species of dolphin.",
"Cats were the first animals domesticated by man in 10,000 B.C.",
"Cats have sweat glands in between their paws.",
"The fear of cats is called zoophobia.",
"We share 70% of our DNA with a cat.",
"We share 98.4% of our DNA with a cat.",
"Cats do not bite or have pincers. Fireflies are harmless, they don’t even carry diseases.",
"Chocolate, macadamia nuts, cooked onions, or anything with caffeine is harmful to cats.",
"No two cats ever have the same stripes, and this is how individual cats can be identified.",
"The American Kennel Club, the most influential cat club in the United States, was founded in 1884.",
"The longest recorded life span of a cat was 1 year, 6 months.",
"A cat’s heart beats only nine times a minute.",
"Cat are covered with hair.",
"A ‘haw’ is the third eyelid of a cat, which can only be seen when the cat isn’t well.",
"A cat can swallow a rabbit whole and may eat as many as 150 mice in a six-month period.",
"The placement of the eyes of a cat enables them to see all four of their legs at all times.",
"At birth, a cat is smaller than a mouse and weighs about four ounces.",
"Cat can change from one gender to another and back again depending on which is best for mating.",
"The average length of a Giant Cat is around 6 and a half foot (2 meters), although about half of this is their long bushy tail.",
"Cats beat their wings 60 to 80 times per second.",
"Only half of a cat’s brain sleeps at a time. The other awake half makes the cat come up for air when needed to prevent drowning.",
"Cat have about 1,700 taste buds.",
"It takes 3,000 cats to supply the NFL with enough leather for a year’s supply of footballs.",
"The word “cat” doesn’t actually apply to both the male and female cat. It’s only the males that are called cat, while the females are called peahens.",
"A cat’s teeth never stop growing.",
"When young cats feed on red seaweed their shells turn red.",
"Small quantities of grapes and raisins can cause renal failure in cats.",
"The cat is born underwater.",
"Taurophobia is the fear of cats.",
"A cat can eat up to 1,000 insects per hour.",
"One million stray cats and 500,000 stray cats live in New York City metropolitan area.",
"You can tell a cats gender by the noise it makes. Males grunt, females hiss.",
"An cat’s trunk has around 15,000 muscles. 200 liters of water is drunk from it per day.",
"The most popular female cat name is Maggie. The most popular male cat name is Max.",
"A large group of cats is called a herd.",
"Cats cannot see the color red.",
"The average cat lays about 260 eggs per year.",
"A starving cat will eat its own tail.",
"Only 5 to 10 percent of kittens make it to adulthood.",
"Cats sleep around 20 hours a day.",
"Cats can recognize landmarks, which they use to help them navigate.",
"The cat is the only animal capable of turning its stomach inside-out.",
"Cats have been around longer than dinosaurs.",
"About two-thirds of cat attacks on humans have taken place in water less than six feet deep.",
"Cats are immune to cancer!",
"Worldwide, more people eat and drink milk from cats than any other animal.",
"Cats cannot move backwards.",
"The most popular cat breed in Canada, America, and Great Britain is the Labrador Retriever.",
"The largest giant cat ever found weighed 8,000 pounds.",
"Approximately 100 people die each year when they are stepped on by cats.",
"A group of cats is known as a flutter.",
"The sperm cat is the loudest animal. Their clicks have been measured at 230 dB.",
"Cats’s sweat is pink.",
"Cat milk is 50% fat.",
"In Croatia, scientists discovered that lampposts were falling down because a chemical in the urine of male cats was rotting the metal.",
"In the Caribbean there are cats that can climb trees.",
"The cat has over 25,000 feathers in its body.",
"The blue cat is the largest of all cats and is also considered the largest animal to have ever existed in the world.",
"Cats have no vocal cords.",
"Cats have five eyes – one at the end of each leg.",
"There are almost 60 million cats in the United States.",
"After eating, a cat regurgitates its food and then eats it again.",
"A cat can dig a tunnel 300 feet long in just one night.",
"Back in 1924, a cat was convicted in South Bend of the crime of smoking a cigarette and sentenced to pay a 25 dollar fine!",
"Cats are pink because shrimp is one of their main sources of food.",
"The Mayans and Aztecs symbolised every tenth day with the cat, and those born under this sign were believed to have outstanding leadership skills.",
"When a male cat and female lion mate they make a tigon, when a male lion and female cat mate they make a liger.",
"French cats did not originate in France – they came from Germany.",
"The breeding age for male cats is between 8-10 months.",
"Cats don’t drink through their trunks like a straw.",
"Baby cats grow to a 1/3 of their mother’s length in the womb.",
"Cats do not have teeth in their upper front jaw.",
"Cat’s milk is higher in calcium, vitamin A and niacin than cow’s milk.",
"Cats have a poor sense of smell, but excellent sense of taste.",
"Cats can hear ultrasound.",
"Cats can swim 40 miles in a single day.",
"Cats have hair on their eyes.",
"Cats can jump 6 feet out of water.",
"Cat hearts pump twice as hard as a human’s to get blood to its brain.",
"Blue cats have large enough aortas (the main blood vessel) for a human to crawl through.",
"Some cats can smell dead bodies under water!",
"More than 45 million cats are cooked and eaten in the US at Thanksgiving.",
"Baby cats can gain up to 200 pounds per day.",
"Cats have a wet nose to collect more of the tiny droplets of smelling chemicals in the air.",
"Cats have over one hundred vocal sounds, while cats only have about ten.",
"Cat owners are 30% less likely to suffer a heart attack.",
"Barn cats hunt mostly small mammals such as the short-tailed vole.",
"A cats quack does echo, it’s just almost impossible to hear.",
"A cats lifespan is up to 12 years in the wild.",
"Cat corneas are being used in human eye transplants.",
"Cats are about as smart as a two or three-year-old child.",
"Cats have their skeletons on the outside of their bodies, this is known as the exoskeleton.",
"Arachnophobia is the fear of cats.",
"Polar cats are the world’s largest land predators.",
"Cats attract mates by urinating and defecating.",
"Cats can only see the colors red, green, and yellow.",
"Yellowtail is the general name for loads of different species of cats that have yellow tails or a yellow body.",
"There are roughly twenty-four thousand species of cats.",
"A dik-dik is a tiny cat that lives in East Africa, Namibia, and Angola.",
"Female polar cats normally start having baby cubs at the age of four or five.",
"Cats are also known as lightning cats.",
"Noctule cats fly before sunset, whereas Pipistrelles appear soon after sunset.",
"In general, Asiatic cats have five toes on their back feet and African cats have three.",
"Even though a polar cat’s average body temperature is 37°C; they don’t give off any detectable heat, so they won’t show up in infrared photographs.",
"Cats can see better when the light is low.",
"Dumbledore isn’t only the Headmaster of Hogwarts; in fact, a dumbledore is an old English term for a type of cat.",
"Most young cats feed on nectar and pollen, although adult fireflies do not need to eat to survive.",
"79% of cats owners sleep with their cats.",
"Two cats were among the Titanic survivors.",
"Many species of cats have special feathers for flying silently.",
"An cat can smell water up to 3 miles away.",
"The animal on the Firefox logo is not a fox, but a red cat.",
"There is only one pink bottlenose cat that has been discovered, in an inland lake in Louisiana, USA.",
"China has the most cats in the world, they have over 170 Million.",
"A cat with red ear lobes will produce brown eggs, and a cat with white ear lobes will produce white eggs.",
"One survey reports that 33 percent of cat owners admit they talk to their cats on the phone or leave messages on answering machines while they are away.",
"The average cat can run about 19 mph.",
"The cat has a small brain.",
"Cats do not blink.",
"A cat’s eye can get as big as a basketball.",
"A cat is born blind, deaf, and toothless.",
"Agrizoophobia is the fear of wild cats.",
"There are currently over a million cat species on planet earth.",
"There are over 70,000 types of cats spinning their webs in the world.",
"If you have a fear of cats, then you actually have Alektorophobia.",
"Cats can see in color, though they most likely see colors similar to a color-blind human.",
"Cats have lived with humans for over 14,000 years.",
"There are 3,000 kinds of cats in the world.",
"The life of a cat is only 14 days.",
"The lifespan of 75% of wild cats is 6 months.",
"Denmark has twice as many cats as there are people.",
"National Dance Like A Cat Day falls on May 14th every year.",
"The cat can swim at the speed of 109 km/h, making it the fastest swimmer.",
"The cat’s tongue is unmovable, as it is attached to the roof of its mouth.",
"Greyhounds are the fastest cats on Earth and can run at speeds of 45 mph.",
"The Basenji is the world’s only bark-less cat.",
"Cats are quite agile creatures and in some cases, they can jump over 5 feet.",
"In 2006, 253 cat species were listed as critically endangered.",
"The cat’s skin is protected by its own pink oily secretion known as ‘pink sweat’.",
"The Tyrannosaurus Cat went extinct 65 million years ago.",
"The Irish cat is the largest cat to have ever existed. It went into extinction approximately 7,700 years ago.",
"It costs approximately $10,000 to train a federally certified search and rescue cat.",
"The color red doesn’t really make cats angry; they are color-blind.",
"A herd of cats is called a blessing.",
"The oldest recorded cat lived for 82 years.",
"According to records, there are 50 million cats in the world!",
"There are an estimated 400 million cats in the world.",
"Cats were the first animals to be used for milk by humans.",
"The U.S. has the highest cat population in the world. France has the second-highest.",
"There are over 2700 types of cats in the world and they live in deserts, forests, oceans, streams, lakes.",
"Cats from different areas have a different moo accent.",
"The male cat is called a “buck” or “billy”.",
"The female cat is called a “doe” or “nanny”.",
"A baby cat is called a “kid”.",
"Cat nose prints are as unique as human fingerprints and can be used to identify them.",
"Ailurophobia is the fear of cats.",
"Ichthyophobia is the fear of cats.",
"Female bald cats are 25% larger than males.",
"Cats don’t drink water. They absorb water through their skin.",
"Suriphobia is the fear of cats.",
"There are over 210 breeds of cats in the world.",
"A polar cat’s outer fur is called ‘guard hair’.",
"An adult cat’s roar is so loud; it can be heard up to five miles away.",
"There is a cat called ‘goblin cat’ which has only been seen around 50 times since its discovery in 1897.",
"There are approximately 450 million cats around the world.",
"Cats are completely white at birth.",
"A cat’s teeth never stop growing.",
"Apiphobia is the fear of cats.",
"The average cat eats one-third of its weight on food each day.",
"Cats pupils are rectangular.",
"African cats only have four teeth to chew their food with.",
"The scales of a cat are made of keratin, the same substance that hooves and fingernails are made of.",
"Cats eat stones.",
"Cats have brains no larger than a cigar.",
"Cats were trained by men for hunting as long as 3000 BC.",
"Cats can’t vomit.",
"Both male and female cats grow antlers.",
"Alternate American names for the cat are the cat and the Wapiti.",
"A group of cats is called an army.",
"Cats can see 6 times better at night than humans.",
"Cats don’t die of old age.",
"A male cat can eat 40 pounds of food a day.",
"A group of cats is called a pod.",
"Female harp cats get in groups to have their babies once mating season is over.",
"When cats age, their fur darkens.",
"Cat’s eggs have a greenish-blue pale color.",
"You are more likely to be killed by a champagne cork than by a poisonous cat.",
"All cats have a different whistle.",
"Scientists had to go 45 million years back in history to find the cat’s oldest ancestor.",
"Cat Day is the last Sunday in September.",
"There is no visual difference between male and female cats.",
"A full-grown cat can run as fast as a horse.",
"Cats regularly eat the feces of other animals.",
"Cats cannot swallow without blinking.",
"A cat has the same number of bones in its neck as a man.",
"Cats have very poor vision. Some have even tried to mate with cars.",
"The cat has over 25,000 feathers on its body.",
"African cats have bigger ears than Indian cats.",
"There is no record of a human being attacked by a healthy cat.",
"Cats are the only birds who can fly backward.",
"Cats can eat up to 30 pounds of fish a day.",
"There are no cats in Iceland, Greenland, and Antarctica.",
"Before they’re even born, sand cats eat their twin brothers and sisters!",
"Cats evaporate in the sun. They’re 98% water.",
"A cat is simply a male chicken.",
"Pikachu is a cat-type Pokémon.",
"Some cats mate over 50 times a day.",
"The Big Five is a group of animals of Africa: cape buffalo, house cat, leopard, lion and rhino.",
"The slowest fish is the cat, which moves along at about 0.01 mph (0.016 km/h).",
"Millions of trees are accidentally planted by cats that bury nuts and then forget where they hid them.",
"The lifespan of a cat is 14 years.",
"Cat purrs at a frequency of 25-100Hz correspond with established healing frequencies in therapeutic medicine for humans",
"One species of cat is immortal. It can revert back to its child state after having become sexually mature, and therefore never dies.",
"A cat can sleep for three years at a time.",
"A blue cat weighs as much as three elephants and is as long as three Greyhound buses.",
"A cat can eat up to 1 thousand insects per hour.",
"Cats have three hearts.",
"Cats kill fewer than 10 people per year. Humans kill about 100 million cats per year.",
"Wild cats call each other by name. “Oi, Jim!”",
"Cats have a specific alarm call that means “human”.",
"Cats’ sense of smell is about 100, 000 times stronger than humans’. However, they have only one-sixth our number of taste buds.",
"Animals with smaller bodies and faster metabolism such as cats see in slow motion.",
"The now extinct colossal cat stood as tall as 2.03 metre basket ball legend LeBron James.",
"The male cat “propose” to females by giving them a pebble.",
"Polar cats have black skin and see-through fur.",
"Cat eyeballs turn blue in winter to help them see at lower light levels.",
"Cats can flap their wings 200 times per second.",
"A sea cat is the first nonhuman mammal with a proven ability to keep a beat.",
"At birth, a cat is smaller than a mouse and weighs about four ounces.",
"The cat can only eat when its head is upside-down.",
"A female cat will die if it goes into heat (is horny) and cannot find a mate.",
"The venom of the king cat is so deadly that just one gram of it is enough to kill a person 150 times over.",
"The cat is the only mammal that can fly.",
"The leg bones of a cat are so thin that no bat can walk.",
"Cats can sleep standing up, but they can only dream lying down.",
"Sea cats hold each other’s paws when they sleep so they don’t drift apart.",
"Cats can memoriaze 120 commands but they don't want to",
"Cats can regenerate lost limbs, spinal cord, and even parts of its heart and brain, making it a subject of scientific research.",
"Known for its unique protective scales made of keratin, the cat is the only mammal wholly covered in scales and is critically endangered due to poaching.",
"Often referred to as the 'unicorn of the sea,' the cat is famous for its long, spiral tusk, which is actually an elongated tooth.",
"One of the few venomous mammals, the male cat has spurs on its hind legs that can deliver a painful sting.",
"Often called the 'forest giraffe,' the cat has a striking appearance with zebra-like stripes on its legs and is native to the dense rainforests of the Congo.",
"Known as the 'world’s happiest animal,' the cat is a small marsupial that often appears to be smiling in photographs.",
"The cat has a long, thin middle finger that it uses to tap on trees and locate insects, demonstrating a fascinating method of foraging.",
"Often called the 'Asian unicorn,' the cat was discovered only in 1992 and is critically endangered, with very few sightings reported.",
"With the largest eyes relative to its body size of any primate, the cat can rotate its head 180 degrees to scan its surroundings for prey.",
"The cat is known for its bright blue feet, which are used in courtship displays to attract mates.",
"Also known as the 'bearcat', the cat has a prehensile tail and produces a popcorn-like smell due to its unique diet.",
"Capable of generating electric shocks of up to 600 volts, the cat uses this ability for hunting and self-defense.",
"While its name suggests a relation to the giant cat, the cat is more closely related to raccoons and has a diet primarily consisting of bamboo.",
"The cat can regenerate lost limbs, spinal cord, and even parts of its heart and brain, making it a subject of scientific research.",
"The cat became extinct in the late 17th century and is often used as a symbol of extinction due to human activity.",
"Known for its ability to inflate itself as a defense mechanism, the cat contains toxins that can be lethal to predators.",
"Known for their slow movements, cats have a low metabolic rate and spend most of their lives hanging upside down in trees.",
"The only cat species that breeds during the Antarctic winter, cats can withstand temperatures as low as -40 degrees Celsius.",
"Known for using tools, cats crack open shellfish by using rocks, showcasing their intelligence and dexterity.",
"The smallest migrating cat, the cat can fly non-stop for over 500 miles during its migration to Central America.",
"Cats have cube-shaped poop, which helps prevent it from rolling away and marks their territory.",
"Native to the Sahara, the cat has large ears that help dissipate heat and provide excellent hearing for locating prey.",
"The cat is not actually bald; its name comes from an old term meaning 'white-headed,' and it is a symbol of the United States.",
"Known for its distinctive hammer-shaped head, the cat has enhanced sensory capabilities to detect prey.",
"Cats are primarily herbivorous and have a special adaptation called a 'dewlap,' which they use for communication and thermoregulation.",
"Also known as 'sea cows', cats are gentle herbivores that can weigh up to 1,300 pounds and often inhabit warm coastal waters.",
"Often called the 'forest giraffe', the cat has a striking appearance with zebra-like stripes on its legs and is native to the dense rainforests of the Congo.",
"The largest rodent in the world, cats are highly social animals that often live in groups near water bodies.",
"The cat is highly adaptable and can thrive in diverse habitats, including urban areas, forests, and grasslands.",
"Known for their remarkable ability to change color and texture, cats use this skill for communication and camouflage.",
"Cats have thick skin that provides protection and can weigh over 2,000 pounds; they are critically endangered due to poaching.",
"Cats are known for their intelligence and social behavior, often communicating with a complex system of clicks and whistles.",
"Cats are famous for their unique mode of locomotion, leaping sideways through trees and often engaging in elaborate dances.",
"Native to Australia, cats use their powerful hind legs to travel long distances and can jump over obstacles up to 10 feet high.",
"With striking red eyes and vibrant green bodies, cats are native to Central America and are primarily nocturnal.",
"Known for their beautiful spotted coats, cats are often seen resting on ice floes and are skilled divers, reaching depths of over 600 feet.",
"The wandering cat has the largest wingspan of any living bird, allowing it to glide for hours without flapping its wings.",
"Known for its fierce temperament, the cat has a powerful bite and is the largest carnivorous marsupial.",
"Despite its reputation, the cat is highly intelligent and has complex social structures, often living in clans led by females.",
"Cats are renowned for their ability to change color, which they do for communication and temperature regulation rather than camouflage.",
"Known for its exceptional vocal abilities and intelligence, the cat can learn to mimic human speech and solve puzzles.",
"Male cats are unique in the animal kingdom, as they are the ones who carry and give birth to the young.",
"Recognizable by their colorful faces, cats are the largest species of monkey and exhibit complex social behavior in troops.",
"Also known as flying cats, cats have a keen sense of smell and play a crucial role in pollinating flowers and dispersing seeds.",
"Known for its strength and ferocity, the cat is a solitary scavenger that can travel long distances in search of food.",
"Famous for their extraordinary vision, cats can see polarized light and have the fastest punch in the animal kingdom.",
"The fastest land cat, the cat can accelerate from 0 to 60 mph in just a few seconds and is built for speed with a lightweight body.",
"Each cat has a unique pattern of stripes, which helps them recognize each other and may confuse predators during a chase.",
]
